module.exports = __webpack_public_path__ + "img/john.f0c37e87.jpg";